function getRuntimeEnv(key) {
  if (typeof window !== 'undefined' && window.__RUNTIME_ENV__ && window.__RUNTIME_ENV__[key] !== undefined) {
    return window.__RUNTIME_ENV__[key];
  }
  if (typeof process !== 'undefined' && process.env) {
    return process.env[key];
  }
  return undefined;
}

module.exports = getRuntimeEnv;
